import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dot: {
    marginHorizontal: theme.spacings.sm,
    width: 12,
    aspectRatio: 1,
    borderRadius: theme.borderRadii.full,
  },
  active: {
    backgroundColor: theme.colors.primary,
  },
  inactive: {
    backgroundColor: '#475569', // convert to theme color if possible
  },
  crossed: {
    backgroundColor: '#94a3b8', // convert to theme color if possible
  },
});
